import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withKeys as _withKeys, createSlots as _createSlots, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d226bf0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "lang"
}
const _hoisted_2 = { class: "selLang" }
const _hoisted_3 = { class: "sysDesc" }
const _hoisted_4 = { id: "loginForm" }
const _hoisted_5 = {
  class: "title animate__animated animate__fadeInDownBig",
  style: {"animation-delay":"0.5s"}
}
const _hoisted_6 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row","justify-content":"space-between"}
}
const _hoisted_7 = { style: {"flex":"3"} }
const _hoisted_8 = { style: {"flex":"1","margin-left":"5px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login_footer" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Copyright © 2022-2023 tools.suxiangkj.com All Rights Reserved.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_VerifyCode = _resolveComponent("VerifyCode")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.otherParams.needMultiLanguage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.otherParams.currentLang,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.otherParams.currentLang) = $event)),
              size: "small",
              style: {"width":"40%"},
              onChange: _cache[1] || (_cache[1] = (val)=>{_ctx.selectOnChange(val,'currentLang')})
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "中文",
                  value: "zh-CN"
                }),
                _createVNode(_component_el_option, {
                  label: "English",
                  value: "en"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.loginClass),
      style: _normalizeStyle({backgroundImage:_ctx.backgroundImage,backgroundSize:'100% 100%'})
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loginMsg, (word) => {
          return (_openBlock(), _createElementBlock("span", null, _toDisplayString(word), 1))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, {
          model: _ctx.loginForm,
          rules: _ctx.loginFormRules,
          ref: el=>_ctx.refMap.set('loginFormRef',el),
          class: "loginForm animate__animated animate__fadeInTopRight",
          style: {"animation-delay":"0.3s"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('login.loginTitle')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "usercode" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  onInput: _cache[2] || (_cache[2] = e => _ctx.loginForm.usercode = _ctx.valid(e)),
                  ref: el=>_ctx.refMap.set('usercodeRef',el),
                  type: "text",
                  placeholder: _ctx.$t('login.usercodePlaceholder'),
                  modelValue: _ctx.loginForm.usercode,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loginForm.usercode) = $event)),
                  autofocus: "true",
                  onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.loginUtilInst.doNext('usercode')), ["enter","native"]))
                }, {
                  suffix: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "iconfont icon-username" })
                  ]),
                  _: 1
                }, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  onInput: _cache[5] || (_cache[5] = e => _ctx.loginForm.password = _ctx.valid(e)),
                  ref: el=>_ctx.refMap.set('passwordRef',el),
                  type: "password",
                  placeholder: _ctx.$t('login.passwordPlaceholder'),
                  modelValue: _ctx.loginForm.password,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                  "show-password": true,
                  onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.loginUtilInst.doNext('password')), ["enter","native"]))
                }, _createSlots({ _: 2 }, [
                  (!_ctx.loginForm.password)
                    ? {
                        name: "suffix",
                        fn: _withCtx(() => [
                          _createVNode(_component_el_icon, { class: "iconfont icon-mima" })
                        ])
                      }
                    : undefined
                ]), 1032, ["placeholder", "modelValue"])
              ]),
              _: 1
            }),
            (_ctx.useYzm)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: "verifyCode"
                }, {
                  default: _withCtx(() => [
                    (_ctx.yzmType=='1')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_el_input, {
                              ref: el=>_ctx.refMap.set('verifyCodeRef',el),
                              type: "text",
                              placeholder: _ctx.$t('login.verifyCodePlaceholder'),
                              modelValue: _ctx.loginForm.verifyCode,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.loginForm.verifyCode) = $event)),
                              clearable: "",
                              onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.loginUtilInst.doNext('verifyCode')), ["enter","native"]))
                            }, null, 8, ["placeholder", "modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_VerifyCode, {
                              ref: el=>_ctx.refMap.set('verifyCodeComRef',el)
                            }, null, 512)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.yzmType=='0')
                      ? (_openBlock(), _createBlock(_component_Slider, {
                          key: 1,
                          status: "silderStatus",
                          ref: el=>_ctx.refMap.set('sliderRef',el),
                          successFun: (() => {_ctx.sliderStatus=true}),
                          errorFun: (() => {})
                        }, null, 8, ["successFun", "errorFun"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loginUtilInst.submitForm())),
                  class: "loginBtn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('login.login')), 1)
                  ]),
                  _: 1
                })), [
                  [
                    _directive_loading,
                    _ctx.fullscreenLoading,
                    void 0,
                    {
                      fullscreen: true,
                      lock: true
                    }
                  ]
                ])
              ]),
              _: 1
            }),
            (_ctx.otherParams.canRegister)
              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "danger",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push('/register'))),
                  class: "loginBtn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('login.register')), 1)
                  ]),
                  _: 1
                })), [
                  [
                    _directive_loading,
                    _ctx.fullscreenLoading,
                    void 0,
                    {
                      fullscreen: true,
                      lock: true
                    }
                  ]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ], 6),
    _hoisted_9
  ], 64))
}